/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CustomerContingentControllerService } from './services/customer-contingent-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CustomerContingentControllerService,
    ApiConfiguration
  ],
})
export class CustomersContingentModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersContingentModule> {
    return {
      ngModule: CustomersContingentModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersContingentModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersContingentModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
